import React, { useEffect, useState } from 'react';
import AuthContext from '../auth/AuthContext';
import { useHistory, useParams } from 'react-router-dom';
import {
	SButton,
	SButtonContainer,
	SCheckbox,
	SDangerSubTitle,
	SDialogButton,
	SInputLabel,
	SLegenda,
	SPanelContainer,
	STitleContainer,
	STitleH3,
	STitleH4
} from '../common/BCommonComponents';
import axios from 'axios';
import { toast } from 'react-toastify';
import { AslDTO, PageMode, PrestazioneConfigDTO, PuntoServizioDTO, UserDTO, UserRole } from '../common/Dtos';
import {
	Box,
	Collapse, FormControl,
	Grid,
	IconButton,
	MenuItem, Select,
	Switch,
	Table,
	TableBody,
	TableContainer,
	TableRow,
	TextField
} from '@material-ui/core';
import { RiAddFill } from 'react-icons/ri';
import { FaChevronLeft, FaHospital, FaLaptop, FaTrash, IoIosArrowDropdown, IoIosArrowDropup } from 'react-icons/all';
import { HeadCell, Order, STableCell, STableHeader, STableRow } from '../common/ScrivaniaTable';
import TableCell from '@material-ui/core/TableCell';
import { InserimentoOperatoriDialog } from './InserimentoOperatoriDialog';
import ConfirmAlertDialog from '../common/ConfirmDialogComponents';
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { AlertDialogContext } from '../common/AlertDialog';

type DettaglioPuntoServizioParameters = {
	id: string
}

export function DettaglioPuntoServizio() {
	const auth = React.useContext(AuthContext);
	const alert = React.useContext(AlertDialogContext);
	const param = useParams<DettaglioPuntoServizioParameters>();
	const history = useHistory();

	const [puntoServizio, setPuntoServizio] = useState<PuntoServizioDTO>({
		cooperativa: '',
		createdBy: '',
		createdDate: '',
		id: '',
		puntoServizioConfig: false,
		indirizzo: '',
		lastModifiedBy: '',
		lastModifiedDate: '',
		name: '',
		operatori: [],
		asl: 'ASL Toscana Sud Est',
		telefono: '',
		email: '',
		codiceDefinitivo: '',
		codiceTemporaneo: '',
		action: '',
		cooperativaName: ''
	});
	const [codTemporaneo, setCodTemporaneo] = useState('');
	const [codDefinitivo, setCodDefinitivo] = useState('');
	const [errorCodici, setErrorCodici] = useState<boolean>(false);
	const [errorCooperativa, setErrorCooperativa] = useState<boolean>(false);
	const [errorAsl, setErrorAsl] = useState<boolean>(false);
	const [prestazioniConfList, setPrestazioniConfList] = useState<PrestazioneConfigDTO[]>([]);
	const [prestazioniConfigAllList, setPrestazioniConfigAllList] = useState<PrestazioneConfigDTO[]>([]);
	const [aslList, setAslList] = useState<AslDTO[]>([]);

	const [selected, setSelected] = React.useState<string[]>([]);
	const [codiceFilter, setCodiceFilter] = useState('');
	const [nomeFilter, setNomeFilter] = useState('');

	const [orderOperatore, setOrderOperatore] = React.useState<Order>('asc');
	const [orderOperatoreBy, setOrderOperatoreBy] = React.useState<string>('id');


	const [orderPrestazione, setOrderPrestazione] = useState<Order>('asc');
	const [orderPrestazioneBy, setOrderPrestazioneBy] = useState<keyof PrestazioneConfigDTO>('id');
	// const [filteredPrestazioniConfigAllList, setFilteredPrestazioniConfigAllList] = useState<PrestazioneConfigDTO[]>([]);

	const [openDialogOperatori, setOpenDialogOperatori] = useState<boolean>(false);
	const [deleteModalVisible, setDeleteModalVisible] = useState(false);
	const [isDeletePs, setIsDeletePs] = useState<boolean>(false);

	const headPrestazioneCells: HeadCell[] = [
		{id: 'collapse', numeric: false, disablePadding: false, label: ' ', sortable: false},
		{id: 'id', numeric: false, disablePadding: false, label: '', sortable: false},
		{id: 'codice', numeric: false, disablePadding: false, label: 'CODICE PRESTAZIONE', sortable: true},
		{id: 'name', numeric: false, disablePadding: true, label: 'PRESTAZIONE', sortable: true},
		{id: 'action', numeric: false, disablePadding: true, label: 'ABILITA PRESTAZIONE', sortable: false}
	];

	const headOperatoriCells: HeadCell[] = [
		{id: 'name', numeric: false, disablePadding: true, label: 'OPERATORE', sortable: true},
		{id: 'email', numeric: false, disablePadding: true, label: 'EMAIL', sortable: true},
	];

	useEffect(() => {
		axios.all([
			auth.state.axiosInstance?.get('/api/puntoServizio/id/' + param.id),
			auth.state.axiosInstance?.get('/api/prestazioneConfig/getAll'),
			auth.state.axiosInstance?.get('/api/puntoServizio/prestazioni/' + param.id),
			auth.state.axiosInstance?.get('/api/puntoServizio/asl/get_all')
		])
			.then(axios.spread((res1, res2, res3, res4) => {
				setPuntoServizio(res1?.data);
				setCodDefinitivo(res1?.data.codiceDefinitivo);
				setCodTemporaneo(res1?.data.codiceTemporaneo)
				setPrestazioniConfigAllList(res2?.data);
				setPrestazioniConfList(res3?.data);
				setAslList(res4?.data);
				// setFilteredPrestazioniConfigAllList(res2?.data);
			})).catch(error => {
			toast.error('🛑 Errore durante il recupero del Punto di Servizio e Prestazioni Config!');
			console.log(error);
		});
	}, [auth]);

	useEffect(() => {
	}, [prestazioniConfList, orderPrestazioneBy, orderPrestazione]);

	const handleCodTemporaneoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCodTemporaneo(event.target.value);
	};

	const handleCodDefinitivoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCodDefinitivo(event.target.value);
	};

	const handlePrestazioniSort = (event: React.MouseEvent<unknown>, property: string) => {
		const isAsc = orderPrestazioneBy === property && orderPrestazione === 'asc';
		setOrderPrestazione(isAsc ? 'desc' : 'asc');
		setOrderPrestazioneBy(property as keyof PrestazioneConfigDTO);
		// setFilteredPrestazioniConfigAllList(filteredPrestazioni());
	};

	const handleSelectAllOperatoriClick = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			const newSelecteds = puntoServizio ? puntoServizio.operatori.map((n) => n.id) : [];
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const handleSalvaCodici = () => {
		if (codDefinitivo === '' && codTemporaneo === ''
			|| puntoServizio?.name === ''
			|| puntoServizio?.asl === ''
			|| (puntoServizio?.email && puntoServizio?.email !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(puntoServizio?.email))
			|| (auth.state.roles && auth.state.roles.indexOf(UserRole.ADMIN) >= 0 && puntoServizio?.cooperativa === '')) {
			setErrorAsl(puntoServizio?.asl === '');
			setErrorCodici(true);
		} else {
			setErrorCodici(false);
			setErrorAsl(false);
			const newPunto = {
				cooperativa: puntoServizio?.cooperativa,
				createdBy: puntoServizio?.createdBy,
				createdDate: puntoServizio?.createdDate,
				id: puntoServizio?.id,
				indirizzo: puntoServizio?.indirizzo,
				lastModifiedBy: puntoServizio?.lastModifiedBy,
				lastModifiedDate: puntoServizio?.lastModifiedDate,
				name: puntoServizio?.name,
				operatori: puntoServizio?.operatori,
				asl: puntoServizio?.asl,
				telefono: puntoServizio?.telefono,
				email: puntoServizio?.email,
				codiceDefinitivo: codDefinitivo,
				codiceTemporaneo: codTemporaneo,
				action: '',
			}
			auth.state.axiosInstance?.put('/api/puntoServizio/update/' + puntoServizio?.id, newPunto)
				.then(res => {
					setPuntoServizio(res.data);
					toast.success('Salvataggio avvenuto con successo!');
				})
				.catch(error => {
					toast.error('🛑 Errore durante l\'update del Punto Servizio!');
					console.log(error);
				});
		}
	}

	const handleAssociaPrestazione = (idPrestazione: string, checked: boolean) => {
		auth.state.axiosInstance?.put('/api/puntoServizio/update/prestazioni/' + puntoServizio?.id + '/' + idPrestazione + '/' + checked)
			.then(res => {
				if (auth.state.puntoServizioLogged?.id === puntoServizio?.id) {
					// aggiorno nel localStorage le prestazioni config associate al punto di servizio selezionato in fase di login
					auth.dispatch({
						type: 'UPDATE_PREST', payload:
							{
								prestazioniConfList: res.data
							}
					});
				}
				setPrestazioniConfList(res.data);
			})
			.catch(error => {
				toast.error('🛑 Errore nell\'associazione di una Prestazione ad un Punto Servizio!');
				console.log(error);
			});
	};

	const handleOperatoreClick = (event: React.MouseEvent<unknown>, id: string) => {
		const selectedIndex = selected.indexOf(id);
		let newSelected: string[] = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, id);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1),
			);
		}
		setSelected(newSelected);
	};

	const handleOperatoreRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
		const isAsc = orderOperatoreBy === property && orderOperatore === 'asc';
		setOrderOperatore(isAsc ? 'desc' : 'asc');
		setOrderOperatoreBy(property);
	};

	const handleEliminaOperatoriSelezionati = () => {
		setDeleteModalVisible(true);
		setIsDeletePs(false);
	}

	const closeDeleteModal = () => {
		setDeleteModalVisible(false);
	};

	const confirmDeleteModal = () => {
		if (!isDeletePs) {
			deleteOperatori();
		} else {
			deletePuntoServizio();
		}
	};

	const deleteOperatori = () => {
		let operatori = puntoServizio ? [...puntoServizio.operatori] : [];
		selected.forEach(id => {
			const index = operatori.findIndex(u => u.id === id);
			if (index !== -1) {
				operatori.splice(index, 1);
			}
		});

		const newPunto = {
			cooperativa: puntoServizio?.cooperativa,
			createdBy: puntoServizio?.createdBy,
			createdDate: puntoServizio?.createdDate,
			id: puntoServizio?.id,
			indirizzo: puntoServizio?.indirizzo,
			lastModifiedBy: puntoServizio?.lastModifiedBy,
			lastModifiedDate: puntoServizio?.lastModifiedDate,
			name: puntoServizio?.name,
			operatori: operatori,
			asl: puntoServizio?.asl,
			telefono: puntoServizio?.telefono,
			email: puntoServizio?.email,
			codiceDefinitivo: codDefinitivo,
			codiceTemporaneo: codTemporaneo,
			action: '',
		}
		auth.state.axiosInstance?.put('/api/puntoServizio/update/' + puntoServizio?.id, newPunto)
			.then(res => {
				setDeleteModalVisible(false);
				setPuntoServizio(res.data);
				setSelected([]);
			})
			.catch(error => {
				toast.error('🛑 Errore durante l\'update del Punto Servizio!');
				console.log(error);
			});
	}

	const handleAggiungiOperatori = () => {
		setOpenDialogOperatori(true);
	}

	const handleCodiceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCodiceFilter(event.target.value);
	}

	const handleNomeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setNomeFilter(event.target.value);
	}

	const handleAbilitaTuttePrestazioni = () => {
		const prestIdList: string[] = filteredPrestazioni().map((p) => p.id);
		auth.state.axiosInstance?.put('/api/puntoServizio/prestazioni_abilitate/abilita_sottogruppo/' + puntoServizio?.id, prestIdList)
			.then(res => {
				if (auth.state.puntoServizioLogged?.id === puntoServizio?.id) {
					// aggiorno nel localStorage le prestazioni config associate al punto di servizio selezionato in fase di login
					auth.dispatch({
						type: 'UPDATE_PREST', payload:
							{
								prestazioniConfList: res.data
							}
					});
				}
				setPrestazioniConfList(res.data);
			})
			.catch(error => {
				toast.error('🛑 Errore nell\'associazione di tutte le Prestazione ad un Punto Servizio!');
				console.log(error);
			});
	}

	const handleDisabilitaTuttePrestazioni = () => {
		const prestIdList: string[] = filteredPrestazioni().map((p) => p.id);
		auth.state.axiosInstance?.put('/api/puntoServizio/prestazioni_abilitate/disabilita_sottogruppo/' + puntoServizio?.id, prestIdList)
			.then(res => {
				if (auth.state.puntoServizioLogged?.id === puntoServizio?.id) {
					// aggiorno nel localStorage le prestazioni config associate al punto di servizio selezionato in fase di login
					auth.dispatch({
						type: 'UPDATE_PREST', payload:
							{
								prestazioniConfList: res.data
							}
					});
				}
				setPrestazioniConfList(res.data);
			})
			.catch(error => {
				toast.error('🛑 Errore nella disassociazione di tutte le Prestazione ad un Punto Servizio!');
				console.log(error);
			});
	}

	const handleCloseDialogOperatori = (selected?: UserDTO[]) => {
		setOpenDialogOperatori(false);

		if (selected && selected.length > 0) {
			let newOperatori = puntoServizio ? [...puntoServizio.operatori] : [];
			newOperatori = newOperatori.concat(selected)
			const newPunto = {
				cooperativa: puntoServizio?.cooperativa,
				createdBy: puntoServizio?.createdBy,
				createdDate: puntoServizio?.createdDate,
				id: puntoServizio?.id,
				indirizzo: puntoServizio?.indirizzo,
				lastModifiedBy: puntoServizio?.lastModifiedBy,
				lastModifiedDate: puntoServizio?.lastModifiedDate,
				name: puntoServizio?.name,
				operatori: newOperatori,
				asl: puntoServizio?.asl,
				telefono: puntoServizio?.telefono,
				email: puntoServizio?.email,
				codiceDefinitivo: codDefinitivo,
				codiceTemporaneo: codTemporaneo,
				action: '',
			}
			auth.state.axiosInstance?.put('/api/puntoServizio/update/' + puntoServizio?.id, newPunto)
				.then(res => {
					setPuntoServizio(res.data);
					setSelected([]);
				})
				.catch(error => {
					toast.error('🛑 Errore durante l\'update del Punto Servizio!');
					console.log(error);
				});
		}
	};

	const comparator = (a: PrestazioneConfigDTO, b: PrestazioneConfigDTO): number => {
		if (a[orderPrestazioneBy] > b[orderPrestazioneBy]) {
			return orderPrestazione === 'desc' ? -1 : 1;
		}

		if (a[orderPrestazioneBy] < b[orderPrestazioneBy]) {
			return orderPrestazione === 'desc' ? 1 : -1;
		}

		return 0;
	}

	const filteredPrestazioni = (): PrestazioneConfigDTO[] => {
		let filtered = [...prestazioniConfigAllList];

		if (codiceFilter && codiceFilter !== '') {
			filtered = filtered.filter(p => p.codice.toLowerCase().includes(codiceFilter.trim().toLowerCase()));
		}

		if (nomeFilter && nomeFilter !== '') {
			filtered = filtered.filter(p => p.name.toLowerCase().includes(nomeFilter.trim().toLowerCase()));
		}
		filtered = filtered.sort(comparator)
		return filtered
	}

	const isSelected = (id: string) => selected.indexOf(id) !== -1;

	const handleGoBack = () => {
		history.push('/puntiservizio');
	}

	const handleNomePuntoChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newPunto = {
			...puntoServizio,
			name: event.target.value as string
		}
		setPuntoServizio(newPunto as PuntoServizioDTO);
	};

	const handleASLChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newPunto = {
			...puntoServizio,
			asl: event.target.value as string
		}
		setPuntoServizio(newPunto as PuntoServizioDTO);
	};

	const handleCooperativaChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newPunto = {
			...puntoServizio,
			cooperativa: event.target.value as string
		}
		setPuntoServizio(newPunto as PuntoServizioDTO);
	};

	const handleIndirizzoChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newPunto = {
			...puntoServizio,
			indirizzo: event.target.value as string
		}
		setPuntoServizio(newPunto as PuntoServizioDTO);
	};

	const handleEmailChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newPunto = {
			...puntoServizio,
			email: event.target.value as string
		}
		setPuntoServizio(newPunto as PuntoServizioDTO);
	};

	const handleTelefonoChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		const newPunto = {
			...puntoServizio,
			telefono: event.target.value as string
		}
		setPuntoServizio(newPunto as PuntoServizioDTO);
	};

	const handleEliminaPs = () => {
		setDeleteModalVisible(true);
		setIsDeletePs(true);
	}

	const deletePuntoServizio = () => {
		setDeleteModalVisible(false);
		auth.state.axiosInstance?.delete('/api/puntoServizio/delete/' + puntoServizio.id)
			.then(res => {
				toast.success('Punto di Servizio ' + puntoServizio.name + ' eliminato con successo!');
				history.push('/puntiservizio');
			})
			.catch(error => {
				if (406 === error.response.status) {
					alert.setAlertMessage(error.response.data.message);
					alert.setShowAlert(true);
				} else {
					toast.error('🛑 Errore durante la cancellazione del Punto di Servizio!');
				}
				console.log(error);
			});
	};

	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);

	const classes = useStyles();


	return (
		<div>
			<STitleContainer>
				<STitleH3> {puntoServizio?.name} </STitleH3>
			</STitleContainer>
			<Grid container spacing={0} className="w-100">
				<Grid item xs={3}>
					<TextField
						className="w-100"
						id="nomePunto"
						label="Nome"
						variant="outlined"
						value={puntoServizio?.name}
						onChange={handleNomePuntoChange}
						InputLabelProps={{shrink: true}}
					/>
				</Grid>
				<Grid item xs={3} className="pl-2">
					<FormControl variant="outlined" className={classes.formControl} error={errorAsl} required={true}>
						<SInputLabel id="asl">ASL</SInputLabel>
						<Select
							required
							labelId="asl"
							id="asl"
							className={classes.selectEmpty}
							label="ASL"
							value={puntoServizio?.asl}
							onChange={handleASLChange}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "left"
								},
								transformOrigin: {
									vertical: "top",
									horizontal: "left"
								},
								getContentAnchorEl: null
							}}
						>
							{aslList && aslList.map(asl => {
								return (
									<MenuItem value={asl.id} key={asl.id}>{asl.name}</MenuItem>
								)
							})}
						</Select>
					</FormControl>
				</Grid>
				<Grid item xs={3} className="pl-2">
					<TextField
						disabled
						className="w-100"
						id="cooperativaNome"
						label="Cooperativa"
						type="text"
						variant="outlined"
						value={puntoServizio?.cooperativaName}
						onChange={handleCooperativaChange}
						error={errorCooperativa}
						InputLabelProps={{shrink: true}}
					/>
				</Grid>
				<Grid container spacing={1} className="mt-3 w-100">
					<Grid item xs={3}>
						<TextField
							className="w-100"
							id="indirizzo"
							label="Indirizzo"
							type="text"
							variant="outlined"
							value={puntoServizio?.indirizzo}
							onChange={handleIndirizzoChange}
							InputLabelProps={{shrink: true}}
						/>
					</Grid>
					<Grid item xs={2}>
						<TextField
							className="w-100"
							id="email"
							label="Email"
							type="email"
							variant="outlined"
							value={puntoServizio?.email}
							onChange={handleEmailChange}
							InputLabelProps={{shrink: true}}
						/>
					</Grid>
					<Grid item xs={2}>
						<TextField
							className="w-100"
							id="telefono"
							label="Telefono"
							type="phone"
							variant="outlined"
							value={puntoServizio?.telefono}
							onChange={handleTelefonoChange}
							InputLabelProps={{shrink: true}}
						/>
					</Grid>
				</Grid>
			</Grid>
			<Grid container spacing={1} className="mt-3 w-100 align-items-center">
				<Grid item xs={3}>
					<TextField
						className="w-100"
						id="codTemporaneoInput"
						label="Codice temporaneo"
						variant="outlined"
						value={codTemporaneo}
						onChange={handleCodTemporaneoChange}
						InputLabelProps={{shrink: true}}
					/>
				</Grid>
				<Grid item xs={3}>
					<TextField
						className="w-100"
						id="codDefinitivoInput"
						label="Codice definitivo"
						variant="outlined"
						value={codDefinitivo}
						onChange={handleCodDefinitivoChange}
						InputLabelProps={{shrink: true}}
					/>
				</Grid>
				<Grid item xs={6} className="d-flex justify-content-end">
					<SButton onClick={handleSalvaCodici} className="d-flex">Salva</SButton>
					{puntoServizio.id != '' && puntoServizio.id !== auth.state.puntoServizioLogged?.id &&
					<SButton variant="rosso" onClick={handleEliminaPs}>Elimina</SButton>
					}
				</Grid>
			</Grid>
			<SDangerSubTitle className="text-left" hidden={!errorCodici}>Almeno uno dei due codici deve essere
				compilato!</SDangerSubTitle>
			<SPanelContainer>
				<STitleH4> OPERATORI ASSOCIATI </STitleH4>
				<SButtonContainer>
					<SButton onClick={handleAggiungiOperatori}><RiAddFill className="mr-2"/>Aggiungi</SButton>
					<SButton onClick={handleEliminaOperatoriSelezionati} variant="rosso"
									 disabled={!selected || selected.length === 0}><FaTrash className="mr-2"/>Elimina</SButton>
				</SButtonContainer>

				<TableContainer className="max-height-table">
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table"
						stickyHeader
					>
						<STableHeader
							numSelected={selected.length}
							order={orderOperatore}
							orderBy={orderOperatoreBy}
							onSelectAllClick={handleSelectAllOperatoriClick}
							onRequestSort={handleOperatoreRequestSort}
							rowCount={puntoServizio?.operatori ? puntoServizio?.operatori?.length : 0}
							headCells={headOperatoriCells}
							addCheckbox={true}
							bgcolor="primary"
							sortable={true}
							disableAction={false}
						/>
						<TableBody>
							{puntoServizio &&
							puntoServizio?.operatori
								.map((row, index) => {
									const isItemSelected = isSelected(row.id);
									const labelId = `enhanced-table-checkbox-${index}`;

									return (
										<STableRow
											hover
											role="checkbox"
											aria-checked={isItemSelected}
											tabIndex={-1}
											key={row.id}
											selected={isItemSelected}
										>
											<STableCell padding="checkbox">
												<SCheckbox
													checked={isItemSelected}
													inputProps={{'aria-labelledby': labelId}}
													onClick={(event) => handleOperatoreClick(event, row.id)}
												/>
											</STableCell>
											<STableCell padding="none">{row.firstname + ' ' + row.lastname}</STableCell>
											<STableCell padding="none">{row.email}</STableCell>
										</STableRow>
									);
								})}
						</TableBody>
					</Table>
				</TableContainer>


			</SPanelContainer>

			<SPanelContainer>
				<STitleH4> PRESTAZIONI </STitleH4>
				<Grid container spacing={0} className="mb-3 w-100">
					<Grid item xs={3} className="pr-2">
						<TextField
							className="w-100"
							id="codice"
							label="Cerca codice"
							variant="outlined"
							value={codiceFilter}
							onChange={handleCodiceChange}
							InputLabelProps={{shrink: true}}
						/>
					</Grid>
					<Grid item xs={3} className="px-2">
						<TextField
							className="w-100"
							id="prestazione"
							label="Cerca prestazione"
							variant="outlined"
							value={nomeFilter}
							onChange={handleNomeChange}
							InputLabelProps={{shrink: true}}
						/>
					</Grid>
				</Grid>
				<Grid container spacing={1} className="w-100 align-items-center">
					<Grid item xs={8}>
						<SLegenda className="color-primary">LEGENDA: </SLegenda>
						<FaLaptop className="color-secondary mx-1" size={20}/> Attivit&agrave; di BackOffice
						<FaHospital className="color-secondary mx-1" size={20}/> Attivit&agrave; di FrontOffice
					</Grid>
					<Grid item xs={2} className="d-flex justify-content-end">
						<SDialogButton onClick={handleAbilitaTuttePrestazioni} className="w-100">Abilita
							tutti</SDialogButton>
					</Grid>
					<Grid item xs={2} className="d-flex justify-content-end">
						<SDialogButton onClick={handleDisabilitaTuttePrestazioni} className="w-100">Disabilita
							tutti</SDialogButton>
					</Grid>
				</Grid>
				<TableContainer className="mt-3 max-height-table">
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table"
						stickyHeader
					>
						<STableHeader
							numSelected={0}
							order={orderPrestazione}
							orderBy={orderPrestazioneBy}
							onRequestSort={handlePrestazioniSort}
							rowCount={filteredPrestazioni() ? filteredPrestazioni().length : 0}
							headCells={headPrestazioneCells}
							addCheckbox={false}
							bgcolor="primary"
							sortable={true}
							disableAction={false}
						/>
						<TableBody>
							{filteredPrestazioni().map((row, index) => {
								const labelId = `enhanced-table-checkbox-${index}`;
								return (
									<SimplePrestazioneViewRow row={row} labelid={labelId}
																						prestazioniConfList={prestazioniConfList}
																						onSwitchChange={handleAssociaPrestazione}/>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			</SPanelContainer>
			<SButtonContainer>
				<SButton onClick={handleGoBack}><FaChevronLeft/>Torna all'elenco</SButton>
			</SButtonContainer>
			<InserimentoOperatoriDialog open={openDialogOperatori}
																	onClose={handleCloseDialogOperatori}
																	alreadyAssociated={puntoServizio ? puntoServizio.operatori : []}
																	cooperativa={puntoServizio ? puntoServizio.cooperativa : ''}/>
			<ConfirmAlertDialog
				open={deleteModalVisible}
				onCancel={closeDeleteModal}
				onConfirm={confirmDeleteModal}
				message={'Sei sicuro di voler procedere con la cancellazione?'}
			/>
		</div>
	);
}

interface RowProps {
	row: PrestazioneConfigDTO;
	labelid: string;
	prestazioniConfList: PrestazioneConfigDTO[];
	onSwitchChange: (idPrestazione: string, checked: boolean) => void;
}

function SimplePrestazioneViewRow(props: RowProps) {
	const {row, labelid, prestazioniConfList, onSwitchChange} = props;
	const [open, setOpen] = React.useState(false);

	const rowHeadCells: HeadCell[] = [
		{id: 'descrizione', numeric: false, disablePadding: false, label: 'DESCRIZIONE', sortable: false},
	];

	const isPrestazioneAssociata = (prestazione: PrestazioneConfigDTO): boolean => {
		return prestazioniConfList.find(prest => prest.codice === prestazione.codice) !== undefined;
	};

	const handleAssociaPrestazione = (event: React.ChangeEvent<HTMLInputElement>, prestazione: PrestazioneConfigDTO) => {
		onSwitchChange(prestazione.id, event.target.checked);
	};

	useEffect(() => {

	}, []);

	return (
		<React.Fragment>
			<STableRow>
				<STableCell style={{width: '5%', borderBottom: 'none'}} component="th" id={labelid} padding="none">
					<IconButton className="color-primary" aria-label="expand row" size="small"
											onClick={() => setOpen(!open)}>
						{open ? <IoIosArrowDropup size={20}/> : <IoIosArrowDropdown size={20}/>}
					</IconButton>
				</STableCell>
				<STableCell style={{borderBottom: "none", width: '5%'}} component="th" id={row.id} padding="default"
										size="small" className="text-center">
					{
						row.type === 'BACKOFFICE' ? <FaLaptop className="color-secondary" size={30}/> :
							<FaHospital className="color-secondary" size={30}/>
					}
				</STableCell>
				<STableCell style={{borderBottom: "none"}} padding="default">{row.codice}</STableCell>
				<STableCell style={{borderBottom: "none"}} padding="none">{row.name}</STableCell>
				{/*<STableCell style={{borderBottom: "none"}} padding="none">{row.description ? row.description : '-'}</STableCell>*/}
				<STableCell style={{borderBottom: "none"}} padding="none" className="text-center">
					<Switch
						checked={isPrestazioneAssociata(row)}
						onChange={(event) => handleAssociaPrestazione(event, row)}
						color="primary"
						name="associaSwitch"
						inputProps={{'aria-label': 'primary checkbox'}}
					/>
				</STableCell>
			</STableRow>
			<TableRow className="bg-white">
				<TableCell style={{paddingBottom: 0, paddingTop: 0, paddingLeft: 50, paddingRight: 0}} colSpan={12}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Box className="mt-3">
							<Table size="small" aria-label="purchases">
								<STableHeader
									numSelected={0}
									rowCount={row.subTask ? row.subTask.length : 0}
									headCells={rowHeadCells}
									addCheckbox={false}
									bgcolor="secondary"
									sortable={false}
									checkboxDisabled={true}
									disableAction={false}
								/>
								<TableBody>
									{row.subTask && row.subTask.map((subTaskRow, index) => {
											return (
												<STableRow>
													<STableCell component="th" scope="row">{subTaskRow}</STableCell>
												</STableRow>
											);
										}
									)}
								</TableBody>
							</Table>
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</React.Fragment>
	)
}
